import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useAppDispatch, useAppSelector } from 'helpers/redux';
import { RootState } from 'app/store';

import JobTypeForm from '../components/JobTypeForm';
import { InputModel, JobType } from '../models';
import { HttpClientError, RequestStatus } from 'http-client';
import {
    createJobType, getList,
    reset,
    updateJobType,
} from '../jobType.reducer';
import {savedStatusOption} from "../../../../helpers/alertLabel";

const JobTypeDetailPage = ({
    isEdit = false, ...props
}: JobTypeDetailPageProps) => {
    const dispatch = useAppDispatch();
    const MySwal = withReactContent(Swal);

    const isLoading = useAppSelector(
        (state: RootState) => state.jobType.isLoading ?? false
    );
    const singleState = useAppSelector(
        (state: RootState) => state.jobType.single ?? ({} as JobType)
    );
    const status = useAppSelector((state: RootState) => state.jobType.status);
    const error = useAppSelector(
        (state: RootState) => state.jobType.error ?? ({} as HttpClientError)
    );

    const onSubmit = (formInput: InputModel) => {
        if (isEdit) {
            let _formInput = { ...formInput, id: singleState.id };
            dispatch(updateJobType(_formInput));
        } else {
            dispatch(createJobType(formInput));
        }
        dispatch(reset());
    };

    useEffect(() => {
        if (status !== undefined && status !== RequestStatus.pending) {
            MySwal.fire(savedStatusOption(status === RequestStatus.success, error.data?.message)).then(() => {
                dispatch(reset());
                dispatch(getList({ skip: 0, take: 10 }));
                props.toggleModal();
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status, error]);

    return (
        <div className="p-2 md:p-6 pt-2 md:pt-2 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
            <JobTypeForm
                isLoading={isLoading}
                isEdit={isEdit}
                onSubmit={onSubmit}
            />
        </div>
    );
};

export interface JobTypeDetailPageProps {
    isEdit: boolean;
    toggleModal: () => void;
}

export default JobTypeDetailPage;
